// Auth actions
export const AUTH_SAVE = 'AUTH_SAVE';
export const AUTH_SET_SECOND = 'AUTH_SET_SECOND';
export const AUTH_CLEAR = 'AUTH_CLEAR';
export const AUTH_HIDE_DATA = 'AUTH_HIDE_DATA';

// Common actions
export const COMMON_ALERT = 'COMMON_ALERT';
export const COMMON_CLOSE_ALERT = 'COMMON_CLOSE_ALERT';
export const COMMON_MODAL_RESIZE = 'COMMON_MODAL_RESIZE';
export const COMMON_SCROLL_TOP = 'COMMON_SCROLL_TOP';
export const COMMON_SCROLL_TO = 'COMMON_SCROLL_TO';

// DDNY actions
export const DDNY_ATTRIBUTES = 'DDNY_ATTRIBUTES';
export const DDNY_FILTERS = 'DDNY_FILTERS';

// Diamond actions
export const DIAMONDS_FILTER_SAVE = 'DIAMONDS_FILTER_SAVE';
export const DIAMONDS_SAVE = 'DIAMONDS_SAVE';
export const DIAMONDS_SAVE_SELECTED = 'DIAMONDS_SAVE_SELECTED';
export const DIAMONDS_SET_LAST_POSITION = 'DIAMONDS_SET_LAST_POSITION';
export const DIAMONDS_SET_SOURCE = 'DIAMONDS_SET_SOURCE';
export const DIAMONDS_TOGGLE_LIST = 'DIAMONDS_TOGGLE_LIST';

// Employee actions
export const EMPLOYEES_UNCHECK_ENTRIES = 'EMPLOYEES_UNCHECK_ENTRIES';
export const EMPLOYEES_SET_MODAL = 'EMPLOYEES_SET_MODAL';
export const EMPLOYEES_SET_MODAL_MODE = 'EMPLOYEES_SET_MODAL_MODE';
export const EMPLOYEES_SET_SELECTED = 'EMPLOYEES_SET_SELECTED';
export const EMPLOYEES_SET_SORT_TYPE = 'EMPLOYEES_SET_SORT_TYPE';
export const EMPLOYEES_SET_SORT_REVERSE = 'EMPLOYEES_SET_SORT_REVERSE';

// Header actions
export const HEADER_TITLE = 'HEADER_TITLE';
export const HEADER_CLOSE_SEND_LEAD = 'HEADER_CLOSE_SEND_LEAD';
export const HEADER_OPEN_SEND_LEAD = 'HEADER_OPEN_SEND_LEAD';

// Jewelry actions
export const JEWELRY_FILTER_SAVE = 'JEWELRY_FILTER_SAVE';
export const JEWELRY_SAVE = 'JEWELRY_SAVE';
export const JEWELRY_SAVE_SELECTED = 'JEWELRY_SAVE_SELECTED';
export const JEWELRY_SET_LAST_POSITION = 'JEWELRY_SET_LAST_POSITION';
export const JEWELRY_TOGGLE_LIST = 'JEWELRY_TOGGLE_LIST';

// Leads actions
export const LEADS_FILTER_SAVE = 'LEADS_FILTER_SAVE';
export const LEADS_SAVE = 'LEADS_SAVE';
export const LEADS_CLOSE_ADD_DROPDOWN = 'LEADS_CLOSE_ADD_DROPDOWN';
export const LEADS_OPEN_ADD_DROPDOWN = 'LEADS_OPEN_ADD_DROPDOWN';
export const LEADS_SAVE_DIRECTORY = 'LEADS_SAVE_DIRECTORY';
export const LEADS_CLOSE_SHARE_DIRECT_DROPDOWN = 'LEADS_CLOSE_SHARE_DIRECT_DROPDOWN';
export const LEADS_OPEN_SHARE_DIRECT_DROPDOWN = 'LEADS_OPEN_SHARE_DIRECT_DROPDOWN';

// Login actions
// None

// Messages actions
export const MESSAGES_CLOSE_NEW = 'MESSAGES_CLOSE_NEW';
export const MESSAGES_OPEN_NEW = 'MESSAGES_OPEN_NEW';
export const MESSAGES_OPEN_NEW_DIAMOND = 'MESSAGES_OPEN_NEW_DIAMOND';
export const MESSAGES_SAVE = 'MESSAGES_SAVE';
export const MESSAGES_SAVE_SENT = 'MESSAGES_SAVE_SENT';
export const MESSAGES_SAVE_DIRECTORY = 'MESSAGES_SAVE_DIRECTORY';
export const MESSAGES_SHOW_CONFIRMATION = 'MESSAGES_SHOW_CONFIRMATION';
export const MESSAGES_HIDE_CONFIRMATION = 'MESSAGES_HIDE_CONFIRMATION';
export const MESSAGES_DELETED_SAVE = 'MESSAGES_DELETED_SAVE';

// Store actions
export const STORE_LOCATIONS_SAVE = 'STORE_LOCATIONS_SAVE';
export const STORE_SELECT_LOCATION = 'STORE_SELECT_LOCATION';

// Users actions
export const USERS_SAVE = 'USERS_SAVE';
export const USERS_MODAL_OPEN = 'USERS_MODAL_OPEN';
export const USERS_MODAL_CLOSE = 'USERS_MODAL_CLOSE';
export const USERS_SET_CUSTOMER_CARD = 'USERS_SET_CUSTOMER_CARD';
export const USERS_SET_SELF = 'USERS_SET_SELF';
export const USERS_ADD_TO_SHARE_QUEUE = 'USERS_ADD_TO_SHARE_QUEUE';
export const USERS_RETURN_TO = 'USERS_RETURN_TO';
export const USERS_CARD_TO_EDIT = 'USERS_CARD_TO_EDIT';
export const USERS_FETCH_DIRECTORY_PENDING = 'USERS_FETCH_DIRECTORY_PENDING';

// User (global) actions
export const USER_LOGOUT = 'USER_LOGOUT';

// Watch actions
export const WATCHES_FILTER_SAVE = 'WATCHES_FILTER_SAVE';
export const WATCHES_SAVE = 'WATCHES_SAVE';
export const WATCHES_SAVE_SELECTED = 'WATCHES_SAVE_SELECTED';
export const WATCHES_SET_LAST_POSITION = 'WATCHES_SET_LAST_POSITION';
export const WATCHES_TOGGLE_LIST = 'WATCHES_TOGGLE_LIST';










